import { t } from '@lingui/macro';
import { useEffect, useState } from 'react';
import { useHistory } from '../../hooks/useRouterCompat';
import { useAppUIContext } from '../../context/AppUIContext';
import { WorkspaceTier } from '../../models/local/Types';
import { Fire } from '../../services/FireClient';
import { My } from '../../services/My';
import { Perm } from '../../services/Permission';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../../components/ui/alert-dialog";

const LimitedFeature: React.FC<{ workspaceId: string | undefined | null, tier: WorkspaceTier, content: () => React.ReactNode }> = ({ workspaceId, tier, content }) => {
  const { workspaces } = useAppUIContext();
  const [isEligible, setIsEligible] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const workspace = workspaces.find(w => w.id === workspaceId);
  const history = useHistory();

  useEffect(() => {
    if (workspace) {
      // Permission 서비스 사용
      setIsEligible(Perm.isTierAtLeast(workspace.tier, tier));
    } else if (workspaceId) {
      Fire.ws.getWorkspace(workspaceId).then(ws => {
        setIsEligible(Perm.isTierAtLeast(ws?.tier, tier));
      });
    }
  }, [workspaceId, workspaces, tier]);

  const isWSAdmin = workspace?.owner.id === My.user.id;

  if (isEligible) {
    return <>{content()}</>;
  }

  return (
    <>
      <div onClick={() => setAlertOpen(true)} className='cursor-pointer'>
        <div className="pointer-events-none">
          {content()}
        </div>
      </div>

      <AlertDialog open={alertOpen} onOpenChange={setAlertOpen}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>{t`Feature Locked`}</AlertDialogTitle>
            <AlertDialogDescription>
              {t`To enable this feature, this room must belong to a workspace on ${tier} tier or higher.`}
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>{t`OK`}</AlertDialogCancel>
            {isWSAdmin && (
              <AlertDialogAction onClick={() => history.replace(`/ws/${workspaceId}?view=inquiry`)}>
                {t`Upgrade`}
              </AlertDialogAction>
            )}
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}

export default LimitedFeature;

